import cam from '../../../../../styles/img/account/cam.svg';

const AddPhysicalCard = ({ fidCardNum, setFidCardNum, companyLogo, goToScan }) => {
  const handleCardNumChange = (event) => {
    setFidCardNum(event.target.value);
  };

  return (
    <div className="contenaireNumberFidelity">
      <div className="titre_fidelityscreen">
        Saisir le numéro imprimé sur la carte
      </div>

      <div className="input_box_fidScreen">
        <input
          type="text"
          name="number"
          value={fidCardNum}
          placeholder="Numéro client (13 chiffres)"
          className="input"
          onChange={handleCardNumChange}
        />
        <img src={companyLogo} alt="logo" className="store_logo" />
      </div>

      <button
        type="button"
        onClick={goToScan}
        className="relative btn_fidelitycardScreen"
      >
        Scanner ma carte
        <img src={cam} alt="cam" className="cam" />
      </button>
    </div>
  );
};

export default AddPhysicalCard;